<div class="upload-instructions-modal-body">
	<div class="d-flex justify-content-center">
		<div class="d-flex flex-column upload-instructions-modal-container">
			<!-- Step 1: Template Download -->
			<div class="border rounded p-4 upload-instructions-modal-section">
				<div class="d-flex flex-column w-100">
					<div class="d-flex align-items-center mb-4">
						<div class="number-title">
							{{ 'supplier-upload-step1.SupplierTemplateTitle' | translate }}
						</div>
					</div>
					<div class="mb-4">
						<p class="mb-0 upload-instructions-modal-description">
							{{ 'supplier-upload-step1.SupplierTemplateInfoText' | translate }}
						</p>
					</div>
					<div class="d-flex justify-content-end">
						<eif-custom-button
							[text]="'supplier-upload-step1.SupplierTemplate'"
							(action)="downloadTemplate()">
						</eif-custom-button>
					</div>
				</div>
			</div>
			<!-- Step 2: Instructions -->
			<div class="border rounded p-4 upload-instructions-modal-section">
				<div class="d-flex flex-column w-100">
					<div class="d-flex align-items-center mb-4">
						<div class="number-title">
							{{ 'supplier-upload-step1.SupplierTemplateInstructionsTitle' | translate }}
						</div>
					</div>
					<div>
						<eif-upload-suppliers-instructions
							[showActiveAutomaticFundingRequestInfo]="showActiveAutomaticFundingRequestInfo"></eif-upload-suppliers-instructions>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
